export const BARCODE_TRUST_NUM_FRAMES = 1;
export const SAAS_BARCODE_NUM_FRAMES = 2;
export const SAAS_NUM_FRAMES = 3;
